import { render, staticRenderFns } from "./huahui.vue?vue&type=template&id=5f22bbea"
import script from "./huahui.vue?vue&type=script&lang=js"
export * from "./huahui.vue?vue&type=script&lang=js"
import style0 from "./huahui.vue?vue&type=style&index=0&id=5f22bbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports